<template>
    <div class="">
        <v-card class="flex-container mb-3" style="border-radius: 12px;">
            <v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text mx-5">
                    {{
 $t("res_Label_OrganizationManagement")
                    }}
                </v-toolbar-title>
            </v-toolbar>

            <div class="border-top organization-management-dialog d-flex h-100">
                <div class="treeview-section col-md-4 col-lg-4 d-flex flex-column bg-white h-100">
                    <div class="d-flex gap-2">
                        <div class="flex-1">
                            <div class="search-bar-gray">
                                <v-btn @click="handleSearch()"><v-icon>mdi-magnify</v-icon></v-btn>
                                <v-text-field v-model="searchVal" solo :label="$t('res_Label_SearchPlaceHolder')"
                                              @keydown.enter="handleSearch()"></v-text-field>
                                <v-btn @click="clear()"><v-icon>mdi-close</v-icon></v-btn>
                            </div>
                        </div>
                        <div class="custom-icon-wrapper" v-if="enableAddTopParnetStructure">
                            <v-icon @click="addParentStructure(null);">custom-icon plus-icon</v-icon>
                        </div>
                    </div>
                    <v-treeview class="p-2 flex-1 overflow-auto" dense :active:sync="active" :items="items" ref="tree"
                                :load-children="fetchStructure" :open="openNodes" activatable item-key="tree_id" color="success"
                                open-on-click transition>
                        <template v-slot:prepend="{ item, open }">
                            <div @contextmenu="show($event, item)" :style="{ color: getItemColor(item)}">
                                <v-icon v-if="item.children">{{ open ? 'mdi-folder-open' : 'mdi-folder-multiple-outline'}}</v-icon>
                                <v-icon v-else>mdi-account</v-icon>
                                <span> {{ item.text }}</span>
                            </div>
                        </template>
                        <template v-slot:label="{ item }">
                            <div class="d-flex align-center"
                                 @contextmenu="show($event, item)"
                                 :style="{
                                color: selectedItem === item ? 'black' : getItemColor(item),
                                fontWeight: selectedItem === item ? 'bold' : 'normal'
                                }">
                                <span>
                                    {{ (language === 'ar' && item.nameAr !== '') ? item.nameAr : item.name }}
                                </span>

                                <v-icon v-if="item.haveChild === true" class="ml-2" v-tooltip.hover="$t('res_Tooltip_SubStructureExist')" :style="{ color: selectedItem === item ? 'black' : getItemColor(item) }">
                                    mdi-sitemap
                                </v-icon>
                            </div>
                        </template>


                    </v-treeview>
                </div>
                <div class="form-section col-md-8 col-lg-8 p-0 " v-if="showSignSendPane || showTemplateDelegation || add_edit_Structure || showAutoForwardPane || showUsername
                    || showManageUsers|| footer || showManageTemplates || showStructureStampPane || showManageStructureStampPane
                    || showHeaderFooter || showExportUsersInStructure || showEntityRecipient">

                    <div v-if="showSignSendPane" class="h-100 w-100">
                        <SendSignRule :key="sendSignRuleKey" :structure_id="sendStructureIdProp" :nameOfSelectedStructure="nameOfSelectedStructure" :companyId="companyIdOfSelectedStructureId" :language="language">
                        </SendSignRule>
                    </div>

                    <div v-if="showAutoForwardPane" class="h-100 w-100">
                        <AutoForward :key="templatKey" :structureId="sendStructureIdProp"
                                     :autoForwardRuleDialog="showAutoForwardPane"
                                     @update:autoForwardRuleDialog="showAutoForwardPane = $event"></AutoForward>
                    </div>

                    <div v-if="showTemplateDelegation" class="h-100 w-100">
                        <TemplateDelegate :key="templateDelagationKey" :structure_id="sendStructureIdProp">
                        </TemplateDelegate>
                    </div>
                    <div v-if="showManageTemplates" class="h-100 w-100">
                        <ManageTemplate :key="templatKey" :structure_id="sendStructureIdProp"></ManageTemplate>
                    </div>
                    <div v-if="showStructureStampPane" class="h-100 w-100">
                        <StructureStamp :key="showStructureStampKey" :structure_id="sendStructureIdProp">
                        </StructureStamp>
                    </div>
                    <div v-if="showManageStructureStampPane" class="h-100 w-100">
                        <ManageStructureStamp v-if="constants.allowMultiStamp" :key="showStructureStampKey"
                                              :structure_id="sendStructureIdProp"></ManageStructureStamp>
                    </div>
                    <div :key="manageUsersKey" v-if="showManageUsers" class="h-100 w-100">
                        <ManageUsers 
                         :structureId1="sendStructureIdProp"
                         :structureProps="structureProp"
                         :enableIntialFetchingUsers="true"
                            :fromOrganaize="true"></ManageUsers>
                    </div>
                    <div v-if="showHeaderFooter" class="h-100 w-100">
                        <ManageStructureHeaderFooter :structure_id="sendStructureIdProp"></ManageStructureHeaderFooter>
                    </div>
                    <div v-if="showExportUsersInStructure" class="h-100 w-100">
                        <ExportUsersInStructure :structure_id="sendStructureIdProp"></ExportUsersInStructure>
                    </div>
                    <div v-if="showEntityRecipient" :key="entityRecipientKey" class="h-100 w-100">
                        <ManageEntityRecipients @addIsEntityRecipient="addIsEntityRecipient"
                                                @removeIsEntityRecipient="removeIsEntityRecipient" :fromOrganizaiton=true
                                                :structure_id="sendStructureIdProp"></ManageEntityRecipients>
                    </div>
                    <!-- Add Edit -->
                    <v-card class="h-100" v-if="add_edit_Structure" ref="AddEditStructure">
                        <v-toolbar class="shadow-none" content-class="h-auto">
                            <div class="d-flex align-items-center">
                                <v-toolbar-title class="size-16 dark-text">
                                    {{ this.currentStructureName }} {{
                                    this.currentStructureMode
                                    }}
                                </v-toolbar-title>
                            </div>
                            <v-spacer></v-spacer>
                        </v-toolbar>

                        <div class="border-top p-4 flex-1 overflow-auto">

                            <div class="row">
                                <div class="col-6">
                                    <label>{{ $t("res_Label_Code") }}</label>
                                    <v-text-field v-model="structureForm.code" label="" solo
                                                  height="45px"></v-text-field>
                                </div>
                                <div class="col-6" v-if="showParentSelector">
                                    <label>{{ $t("res_Label_ParentStructure") }}</label>
                                    <StructureUserSelector :showInternalUsers="false" :showExternalUsers="false"
                                                           :showInternalStructures="true" :showExternalStructures="false"
                                                           :excludeSelf="true" :isMultiple="false"
                                                           :selectedStructureUser="selectedParentStructure"
                                                           @structureUserSelectChanged="ParentStructureChange">
                                    </StructureUserSelector>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <label class="">{{ $t("res_Label_Name") }}<span> *</span></label>
                                    <v-text-field v-model="structureForm.name" :rules="rules" label="" solo
                                                  height="45px"></v-text-field>
                                </div>
                                <div class="col-6">
                                    <label>{{ $t("res_Label_NameAr") }}<span> *</span></label>
                                    <v-text-field v-model="structureForm.nameAr" label="" solo height="45px">
                                    </v-text-field>
                                </div>
                            </div>


                            <div class="row">
                                <div class="col-6">
                                    <label>{{ $t('res_Label_DisableTransfer') }}</label>
                                    <v-checkbox v-model="structureForm.disableTransfers" label="" solo></v-checkbox>
                                </div>
                                <div class="col-6">
                                    <label>{{ $t('res_Label_AllowExternalCommunication') }}</label>
                                    <v-checkbox v-model="structureForm.allowExternalCommunication" label="" solo></v-checkbox>
                                </div>
                                
                                <div class="col-6" v-if="structureForm.isCompany" :disabled="!constants.isFullAdmin">
                                    <label>{{ $t('res_Label_isParentCounterFeatureEnabled') }}</label>
                                    <v-checkbox v-model="structureForm.isParentCounterFeatureEnabled" label="" solo></v-checkbox>
                                </div>
                            </div>
                            <div class="field-row" v-if="constants.isFullAdmin && enableEntityConfiguration">
                                <div class="flex-1">
                                    <label>{{ $t('res_Label_IsCompany') }}</label>
                                    <v-checkbox v-model="structureForm.isCompany" :disabled="isEdit" label=""
                                                solo></v-checkbox>
                                </div>
                            </div>
                            <div class="field-row">
                                <div class="flex-1"
                                     v-if="structureForm.isCompany && constants.isFullAdmin && enableEntityConfiguration">
                                    <label>{{ $t('res_Label_StorageDatabaseName') }}</label>
                                    <v-text-field v-model="structureForm.storageDatabaseName" label=""
                                                  solo></v-text-field>
                                </div>
                                <div class="flex-1"
                                     v-if="structureForm.isCompany && constants.isFullAdmin && enableEntityConfiguration">
                                    <label>{{ $t('res_Label_StorageFile') }}</label>
                                    <v-text-field v-model="structureForm.storageFile" label="" solo></v-text-field>
                                </div>
                            </div>
                            <div class="field-row" style="display: none">
                                <div class="flex-1">
                                    <label class="ml-3">{{ $t("res_Label_Manager") }}</label>
                                    <Multiselect style="width: 400px" v-model="structureForm.manager" label="name"
                                                 track-by="id" open-direction="bottom" placeholder="Select manager"
                                                 :options="exceptionUsers" :searchable="true" :loading="loading"
                                                 :internal-search="false" dense :clear-on-select="true" :close-on-select="true"
                                                 :options-limit="300" :max-height="600" :show-no-results="false"
                                                 :hide-selected="false" :multiple="false" outlined
                                                 @search-change="asyncFindExceptionUser" @close="exceptionUsers = []">
                                        <template slot="option" slot-scope="props">
                                            <div style="height: 50px; width: 100%; display: flex">
                                                <div class="" style="">
                                                    <v-avatar color="#eff2f5" size="43">
                                                        {{
                                                        CapitalizeFirstLetter(props.option.name)
                                                        }}
                                                    </v-avatar>
                                                </div>
                                                <div class="ad__box" v-if="props.option.isUser">
                                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                                    <p class="ad__text">
                                                        {{
 GetMultiSelectSubHeaderDisplay(props.option)
                                                        }}
                                                    </p>
                                                </div>
                                                <div class="ad__box" v-else>
                                                    <p class="ad__text__bold">{{ props.option.name }}</p>
                                                    <p class="ad__text">
                                                        {{
 GetMultiSelectSubHeaderDisplay(props.option)
                                                        }}
                                                    </p>
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="noOptions" slot-scope="props">
                                            {{ $t("res_Msgs_EmptySearch") }}
                                        </template>
                                    </Multiselect>
                                </div>
                            </div>

                            <div class="actions d-flex">
                                <v-btn @click="handleSubmit" color="primary" dense>
                                    {{
 $t("res_ButtonText_Submit")
                                    }}
                                </v-btn>
                            </div>
                        </div>
                    </v-card>
                </div>
                <v-menu v-model="showMenu" :position-x="x" :position-y="y" class="menu" :offset-y="offset"
                        :close-on-content-click="false">
                    <v-list>
                        <v-list-item v-for="(item, i) in menuItems" :key="i" @click="openOptionPane(item.id)">
                            <v-icon color="navy" v-text="item.icon"></v-icon>&nbsp;{{ item.title }}
                        </v-list-item>
                    </v-list>
                </v-menu>
            </div>
        </v-card>
    </div>
</template>

<script>
    import axios from 'axios'
    import router from '@/router/index.js'
    import constants from '@/assets/js/constants'
    import Multiselect from 'vue-multiselect'
    import SendSignRule from '@/components/SendSignRule.vue'
    import AutoForward from '@/components/AutoForward.vue'
    import TemplateDelegate from '@/components/TemplateDelegate.vue'
    import ManageTemplate from '@/components/ManageTemplate.vue'
    import StructureStamp from '@/components/StructureStamp.vue'
    import ManageStructureHeaderFooter from '@/components/ManageStructureHeaderFooter.vue'
    import ManageStructureStamp from '@/components/ManageStructureStamp.vue'
    import ManageFilingClassificationPlan from '@/components/ManageFilingClassificationPlan.vue'
    import ManageUsers from './ManageUsers.vue'
    import ExportUsersInStructure from '@/components/ExportUsersInStructure.vue'
    import StructureUserSelector from "@/components/StructureUserSelector.vue";

    import * as utils from '@/assets/js/common.js'
    import ManageEntityRecipients from './ManageEntityRecipients.vue'

    export default {
        name: 'OrgManagement',
        components: { ManageEntityRecipients, StructureUserSelector, SendSignRule, AutoForward, TemplateDelegate, Multiselect, ManageTemplate, StructureStamp, ManageStructureStamp, ManageFilingClassificationPlan, ManageUsers, ManageStructureHeaderFooter, ExportUsersInStructure },
        data() {
            return {
                globalItems: [],
                showParentSelector: false,
                selectedParentStructure: null,
                showUpdateStructureUserBtn: false,
                language: 'en',
                show1: false,
                offset: true,
                password: 'Password',
                active: [],
                currentUserId: 1,
                selectedStructureId: 1,
                selectedParentId: 0,
                nameOfSelectedStructure: '',
                currentStructureMode: '',
                userId: '',
                exceptionUsers: [],
                managers: [],
                selectedUsers: [],
                selectedStructureUserIds: [],
                uploadedFile: [],
                structureForm: {
                    code: '',
                    name: '',
                    manager: [],
                    nameFr: '',
                    nameAr: '',
                    external: false,
                    active: true,
                    disableTransfers: false,
                    document_date_menu: false,
                    date: '',
                    isCompany: false,
                    storageDatabaseName: '',
                    storageFile: ''
                },
                structureData: {
                    structureDataArray: []
                },
                image: null,
                showMenu: false,
                isEdit: false,
                loading: false,
                showUsers: false,
                showManageTemplates: false,
                showManageUsers: false,
                showHeaderFooter: false,
                showUsername: false,
                showExportUsersInStructure: false,
                showEntityRecipient: false,
                searchVal: '',
                rules: [
                    value => !!value || 'This value is required.',
                    value => (value && value.length >= 1),
                ],
                structureHeaders: [
                    { text: 'Id', value: 'id', sortable: false, align: ' d-none' },
                    { text: 'Structure Name', value: 'structure', sortable: false },
                    { text: 'Privacy Level', value: 'privacyLevel', sortable: false },
                    { text: 'Contact Role', value: 'contactRole', sortable: false },
                    { text: 'Profession', value: 'profession', sortable: false },
                    { text: 'Profession Ar', value: 'ProfessionAr', sortable: false },
                    { text: 'Structure Receiver', value: 'isStructureReceiver', sortable: false },
                    { text: 'Designated Person', value: 'isDesignatedPerson', sortable: false },
                ],
                systemRoles: [
                    { text: 'Administrator', value: 1 },
                    { text: 'User', value: 2 }
                ],
                genders: [
                    { text: 'Male', value: 'M' },
                    { text: 'Female', value: 'F' }
                ],
                privacy_items: [],
                contactRoles: [],

                items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
                x: 0,
                y: 0,
                menuItems: [
                    {
                        id: 1,
                        title: this.$t("res_MenuItem_SignAndSend"),
                        icon: 'mdi-send',
                        showForApplications: [1],
                        isShown: true
                    },
                    {
                        id: 2,
                        title: this.$t("res_MenuItem_AutoForward"),
                        icon: 'mdi-security',
                        showForApplications: [1],
                        isShown: window.showAutoforward
                    },

                    {
                        id: 3,
                        title: this.$t("res_MenuItem_DelegationTemplate"),
                        icon: 'mdi-account-switch',
                        showForApplications: [1],
                        isShown: true
                    },
                    {
                        id: 4,
                        title: this.$t("res_MenuItem_Add"),
                        icon: 'mdi-plus-box',
                        showForApplications: [1, 2, 3],
                        isShown: true
                    },
                    {
                        id: 5,
                        title: this.$t("res_MenuItem_Edit"),
                        icon: 'mdi-pencil-box-outline',
                        showForApplications: [1, 2, 3],
                        isShown: true
                    },
                    {
                        id: 6,
                        title: this.$t("res_MenuItem_Delete"),
                        icon: 'mdi-minus-circle',
                        showForApplications: [1, 2, 3],
                        isShown: true
                    },
                    {
                        id: 7,
                        title: this.$t("res_MenuItem_ManageTemplate"),
                        icon: 'mdi-file-document',
                        showForApplications: [1],
                        isShown: true
                    },
                    {
                        id: 8,
                        title: this.$t("res_MenuItem_ActiveStructure"),
                        icon: 'mdi-play-circle',
                        showForApplications: [1, 2, 3],
                        isShown: true
                    },
                    {
                        id: 9,
                        title: this.$t("res_MenuItem_ManageStructureStamp"),
                        icon: 'mdi-stamper',
                        showForApplications: [1],
                        isShown: true
                    },
                    {
                        id: 13,
                        title: this.$t("res_MenuItem_ManageViwerStamp"),
                        icon: 'mdi-postage-stamp',
                        showForApplications: [1],
                        isShown: constants.allowMultiStamp
                    },
                    {
                        id: 14,
                        title: this.$t("res_Title_ManageUsers"),
                        icon: 'mdi-account',
                        showForApplications: [1],
                        isShown: true
                    },
                    {
                        id: 15,
                        title: this.$t("res_Label_ManageHeaderFooter"),
                        icon: 'mdi-page-layout-header-footer',
                        showForApplications: [1],
                        isShown: window.enableStrucutreHeaderFooter
                    },
                    {
                        id: 16,
                        title: this.$t("res_Label_ExportUsersInStructure"),
                        icon: 'mdi-file-excel-outline',
                        showForApplications: [1],
                        isShown: window.enableExportUsersInStructure
                    },
                    {
                        id: 17,
                        title: this.$t("res_Title_ManageEntityRecipients"),
                        icon: 'mdi-view-sequential',
                        showForApplications: [1],
                        isShown: window.enableManageEntityRecipients
                    }
                ],
                Nodes: [],
                items: [],
                openNodes: [],
                clickedUser: true,
                clickedWindow: false,
                showList: false,
                showSignSendPane: false,
                showAutoForwardPane: false,
                showTemplateDelegation: false,
                showStructureStampPane: false,
                showManageStructureStampPane: false,
                showStructureStampKey: 0,
                showManageStructureStampKey: 0,
                delegateKey: 0,
                add_edit_Structure: false,
                editStructureDialog: false,
                addUser: false,
                userMetadata: false,
                disableFields: false,
                disableMailField: false,
                showStructures: false,
                showApplications: false,
                isSubmit: true,
                footer: false,
                sendStructureIdProp: 0,
                companyIdOfSelectedStructureId: 0,
                autoForwardKey: 0,
                templateDelagationKey: 0,
                sendSignRuleKey: 0,
                templatKey: 0,
                fillingPlanKey: 0,
                classificationKey: 0,
                entityRecipientKey: 0,
                constants: constants,
                enableEntityConfiguration: admin_enableEntityConfiguration,
                enableAddTopParnetStructure: false,
                filingClassificationPlanMode: null,
                defaultApplicationId: 1,
                manageUsersKey: 0,
                structureProp: {},
                allCompanies: [],
                selectedItem: null,
                menuItemsToShow: [],
                isLoading: false
            };
        },
        watch: {
            uploadedFile(newSource, oldSource) {
                if (newSource != oldSource) {
                    var binaryData = [];
                    binaryData.push(newSource);
                    this.image = URL.createObjectURL(new Blob(binaryData, { type: "image/png" }))
                }
            }
        },
        mounted() {
            this.defaultApplicationId = this.constants.defaultApplicationId;
            this.asyncFindExceptionUser("");
            this.asyncStructuresTreeView();
            this.getConstantData();
            this.language = localStorage.getItem('lang');
            eval(admin_enableEntityConfiguration);

            if (constants.isFullAdmin) {
                this.enableAddTopParnetStructure = true;
            }

            // show only menu items per application
            this.menuItems.forEach(item => {
                if (item.showForApplications.includes(defaultApplicationId))
                    this.menuItemsToShow.push(item);
            });

            this.menuItems = this.menuItemsToShow;
            this.menuItems = this.menuItems.filter(item => item.isShown);
        },
        methods:
        {
            checkShowManageEntityRecipient(item) {
                if (item.parentId && item.parentId > 0) {
                    return true
                }
                else {
                    return false
                }
            },
            ParentStructureChange(item) {
                this.selectedParentStructure = item;
            },
            getItemColor(item) {
                if (this.constants.client_version_Id === 'DEG')
                    return !item.active ? 'red' : (item.isEntityRecipient ? 'green' : 'black');
                return item.active ? 'inherit' : 'red';
            },
            removeIsEntityRecipient(id) {
                this.items = this.items.map((element) => {
                    if (element.id == id) {
                        element.isEntityRecipient = false
                    }
                    return element;
                })
            },
            addIsEntityRecipient(id) {
                this.items = this.items.map((element) => {
                    if (element.id == id) {
                        element.isEntityRecipient = true
                    }
                    return element;
                })
            },
            async readFile(file, successHandler) {
                var reader = new FileReader();
                var fileByteArray = [];
                reader.readAsArrayBuffer(file);
                reader.onloadend = function (evt) {
                    if (evt.target.readyState == FileReader.DONE) {
                        var arrayBuffer = evt.target.result,
                            array = new Uint8Array(arrayBuffer);
                        for (var i = 0; i < array.length; i++) {
                            fileByteArray.push(array[i]);
                        }

                        successHandler(fileByteArray);
                    }
                }
            },
            getConstantData() {
                this.privacy_items = this.constants.privacies;
                this.contactRoles = this.constants.contactRoles;
            },
            backToAdminPage() {
                router.push({ name: 'admin' })
            },
            showEditStructureUserData(item) {
                this.showUpdateStructureUserBtn = true;
                this.structureData.structure = { name: item.structure, id: item.id };
                this.structureData.structureDisable = true;
                this.structureData.contactRole = this.contactRoles.find(x => x.name == item.contactRole);
                this.structureData.privacyLevel = this.privacy_items.find(x => x.name == item.privacyLevel);
                this.structureData.profession = item.profession;
                this.structureData.professionAr = item.ProfessionAr;
                this.structureData.isStructureReceiver = item.isStructureReceiver;
                this.structureData.isDesignatedPerson = item.isDesignatedPerson;
            },
            handleSearch: function () {
                if (this.searchVal != "") {
                    window.showLoading()
                    var params = "?search=" + this.searchVal;
                    axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForOrganizationManagement' + params, { headers: constants.headers })
                        .then(res => {
                            if (res.data != null) {
                                this.allCompanies = res.data
                                this.openNodes = []
                                this.items = res.data;
                                this.items.forEach(ele => {
                                    this.insertion(ele);
                                });

                                if (this.items.length > 0) {
                                    this.$refs.tree.updateAll(true);
                                }
                            }
                        })
                        .catch(err => console.warn(err))
                        .finally(() => window.hideLoading());
                }
                else {
                    this.asyncStructuresTreeView();
                }
            },
            clear() {
                this.searchVal = '';
                this.items = [];
                this.openNodes = [];
                this.asyncStructuresTreeView();
            },
            insertion: function (ele) {
                ele.isUser = ele.userId != null
                ele.isChild = true
                ele.position = ele.position

                this.openNodes.push(ele.id)
                if (ele.children.length > 0) {
                    ele.children.forEach(item => {
                        this.insertion(item)
                    });
                }
            },
            async asyncStructuresTreeView() {
                this.items = [];
                this.Nodes = [];
                window.showLoading()
                axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForOrganizationManagement')
                    .then((res) => {
                        if (res.data != null) {
                            this.allCompanies = res.data
                            res.data.forEach(element => {
                                var item = {
                                    tree_id: element.id + Math.random(),
                                    id: element.id,
                                    name: element.name,
                                    nameAr: element.nameAr,
                                    children: [],
                                    haveChild: element.haveChild,
                                    active: element.active,
                                    isExternal: element.isExternal,
                                    isEntityRecipient: element.isEntityRecipient ? element.isEntityRecipient : false,
                                    parentId: element.parentId
                                };
                                this.items.push(item);
                            });
                        }
                    }).catch(err => console.warn(err))
                    .finally(() => window.hideLoading());

            },

            asyncFindExceptionUser(query) {
                var methodUrl = 'StructureUser/search?showUsers=true&showInternalStructures=false&showExternalStructures=false&disableOtherInternalEntitiesAsExternal=true&search=';

                axios.get(constants.baseApiUrl + methodUrl + query, { headers: constants.headers })
                    .then(res => {
                        if (res.data != null) {
                            this.exceptionUsers = res.data
                        }
                    })
                    .catch(err => console.warn(err))
            },
            async fetchStructure(item) {
                if (this.isLoading != true) {
                    this.isLoading = true;

                    const existingIndex = this.globalItems.findIndex(node => node.id === item.id);

                    if (existingIndex === -1) {
                        this.globalItems.push(item);
                    }
                    else {
                        this.globalItems[existingIndex] = item; // Replace existing item
                    }
                    window.showLoading()

                    return axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForOrganizationManagement?parentId=' + item.id, { headers: constants.headers })
                        .then(res => {
                            if (res.data != null) {
                                this.allCompanies = res.data
                                var jsonObjects = [];
                                res.data.forEach(element => {
                                    var childItem = {
                                        tree_id: element.id + Math.random(),
                                        id: element.id,
                                        name: element.name,
                                        nameAr: element.nameAr,
                                        children: [],
                                        haveChild: element.haveChild,
                                        active: element.active,
                                        isEntityRecipient: element.isEntityRecipient ? element.isEntityRecipient : false,
                                        parentId: element.parentId
                                    };
                                    jsonObjects.push(childItem);

                                    if (!this.globalItems.some(node => node.id == childItem.id)) {
                                        this.globalItems.push(childItem);
                                    }
                                });

                                this.isLoading = false
                            }

                            item.children.push(...jsonObjects);

                            if (!this.Nodes.some(node => node.id == item.id)) {
                                this.Nodes.push({ id: item.id, parentId: item.parentId });
                            }
                        })
                        .catch(err => {
                            console.warn(err);
                            this.isLoading = false;
                        })
                        .finally(() => window.hideLoading());

                }
            },
            async fetchCurrentStructure(item) {
                window.showLoading()

                return axios.get(constants.baseApiUrl + 'Admin/GetAllStructuresForOrganizationManagement?parentId=' + item.id, { headers: constants.headers })
                    .then(res => {
                        if (res.data != null) {
                            this.allCompanies = res.data
                            var jsonObjects = [];
                            res.data.forEach(element => {
                                var childItem = {
                                    tree_id: element.id + Math.random(),
                                    id: element.id,
                                    name: element.name,
                                    nameAr: element.nameAr,
                                    children: [],
                                    haveChild: element.haveChild,
                                    active: element.active,
                                    isEntityRecipient: element.isEntityRecipient ? element.isEntityRecipient : false,
                                    parentId: element.parentId
                                };

                                const existingIndex = item.children.findIndex(node => node.id === childItem.id);
                                if (existingIndex === -1) {
                                    item.children.push(childItem);
                                }
                                else {
                                    item.children[existingIndex] = childItem; // Replace existing item
                                }

                                if (!this.globalItems.some(node => node.id == childItem.id)) {
                                    this.globalItems.push(childItem);
                                }

                                if (!this.items.some(node => node.id == childItem.id)) {
                                    this.items.push(childItem);
                                }
                            });
                        }
                    })
                    .catch(err => console.warn(err))
                    .finally(() => window.hideLoading());

            },
            getSelectedStructureData(id) {
                return axios.get(constants.baseApiUrl + 'StructureUser/GetSelectedStructure?ids=' + id.toString(), { headers: constants.headers })
                    .then(res => {
                        if (res.data != null) {
                            this.structureForm.code = res.data[0].code
                            this.structureForm.name = res.data[0].name
                            this.structureForm.nameAr = res.data[0].nameAr
                            this.structureForm.external = false
                            this.structureForm.isCompany = res.data[0].isCompany
                            this.structureForm.storageDatabaseName = res.data[0].storageDatabaseName
                            this.structureForm.storageFile = res.data[0].storageFile
                            this.structureForm.disableTransfers = res.data[0].disableTransfers
                            this.structureForm.allowExternalCommunication = res.data[0].allowExternalCommunication
                            this.structureForm.isParentCounterFeatureEnabled = res.data[0].isParentCounterFeatureEnabled
                            this.structureForm.active = res.data[0].active

                            this.selectedParentId = res.data[0].structureParentId
                            this.structureForm.manager = { id: res.data[0].managerId, name: res.data[0].managerName }
                            this.selectedParentStructure = { id: this.selectedParentId, name: res.data[0].structureParentName };
                        }
                    })
                    .catch(err => console.warn(err))
            },
            clearUserDropdown() {
                this.getStructureUserIds(this.selectedStructureId);
            },
            searchSelectedStructureUser() {
                var selectedStructureUserIds = [];
                if (this.structureForm.manager != null) {
                    this.selectedStructureUserIds.forEach(element => {
                        if (element == this.structureForm.manager.id)
                            selectedStructureUserIds.push(element)
                    })
                }
                else
                    this.getStructureUserIds(this.selectedStructureId)

                this.getSelectedUsers(selectedStructureUserIds);
            },
            getStructureUserIds(id) {
                this.selectedStructureUserIds = [];
                return axios.get(constants.baseApiUrl + 'StructureUser/GetSelectedStructureUserIds?id=' + id, { headers: constants.headers })
                    .then(res => {
                        if (res.data != null) {
                            res.data.forEach(element => {
                                this.selectedStructureUserIds.push(element.userId);
                            })
                            this.getSelectedUsers(this.selectedStructureUserIds);
                        }
                    })
                    .catch(err => console.warn(err))
            },
            show(e, item) {
                e.preventDefault()
                this.selectedItem = item; // Set selected item
                this.selectedStructureId = item.id
                this.updateCompanyIdOfSelectedStructureId()
                this.showMenu = false
                this.nameOfSelectedStructure = utils.GetTranslatedValue(item.name, item.nameAr)
                this.x = e.clientX
                this.y = e.clientY
                this.menuItems = this.menuItemsToShow;
                if (window.enableManageEntityRecipients) {
                    if (!constants.isFullAdmin) {
                        this.menuItems.forEach(item => {
                            if (item.id === 17) {
                                item.isShown = false;
                            }
                        });
                    }
                }
                if (!constants.isFullAdmin) {
                    this.menuItems
                    if (item.parentId == null) {
                        this.menuItems.forEach(item => {
                            if (item.id === 5) {
                                item.isShown = false;
                            }
                        });

                    }
                    else if (item.parentId != null) {
                        this.menuItems.forEach(item => {
                            if (item.id === 5) {
                                item.isShown = true;
                            }
                        });
                    }

                    this.menuItems = this.menuItems.filter(x => { return x.isShown == true });
                }
                this.$nextTick(() => {
                    this.showMenu = true
                })
            },
            resetFiles() {
                this.structureForm.code = ''
                this.structureForm.name = ''
                this.structureForm.nameAr = ''
                this.structureForm.nameFr = ''
                this.structureForm.manager = []
                this.structureForm.external = false
                this.structureForm.isCompany = false
                this.structureForm.storageDatabaseName = ''
                this.structureForm.storageFile = ''
                this.structureForm.disableTransfers = false
                this.structureForm.allowExternalCommunication = true
                this.structureForm.isParentCounterFeatureEnabled = false
            },
            isValidForm() {
                if (this.structureForm.name.trim() == '' || this.structureForm.nameAr.trim() == '') {
                    window.showAlert(this.$t("res_Msgs_FillRequired"), 'warning')
                    return false
                }
                return true
            },
            async handleSubmit() {
                if (!this.isValidForm()) {
                    return
                }
                window.showLoading();
                let existingStructure = await this.checkExistence(this.structureForm.name, this.structureForm.nameAr);
                if (existingStructure == '') {
                    await this.submitData();
                    window.hideLoading();
                }
                else {
                    window.showInformation(this.$t("res_Msgs_Confirmation"), this.$t("res_Msgs_WarningCannotAddSameStructure").replace('{0}', existingStructure),
                        async () => {
                            await this.submitData();
                            window.hideLoading();
                        },
                        () => { window.hideLoading(); })
                }
                window.hideLoading();
            },
            async checkExistence(nameEn, nameAr) {
                const response = await axios.get(`${constants.baseApiUrl}StructureUser/CheckStructureExistence?nameEn=${nameEn}&nameAr=${nameAr}`);
                return response.data;
            },
            async submitData() {
                if (this.isEdit) {
                    if (this.structureForm.name && this.structureForm.nameAr) {
                        let updateStructure = {
                            id: this.selectedStructureId,
                            Code: this.structureForm.code,
                            Name: this.structureForm.name,
                            NameAr: this.structureForm.nameAr,
                            StructureParentId: (this.selectedParentStructure == null || this.selectedParentStructure.id == null ? this.selectedParentId : this.selectedParentStructure.id),
                            ModifiedDate: Date.now,
                            External: false,
                            IsCompany: this.structureForm.isCompany,
                            StorageDatabaseName: this.structureForm.storageDatabaseName,
                            StorageFile: this.structureForm.storageFile,
                            DisableTransfers: this.structureForm.disableTransfers,
                            AllowExternalCommunication: this.structureForm.allowExternalCommunication,
                            IsParentCounterFeatureEnabled: this.structureForm.isParentCounterFeatureEnabled,
                            Active: this.structureForm.active,
                        }

                        window.showLoading();
                        axios.post(constants.baseApiUrl + 'StructureUser/UpdateStructureForTreeView', updateStructure, { headers: constants.headers })
                            .then(res => {
                                if (res.data != null) {
                                    window.showAlert('res_Msgs_StructureUpdated', 'success')
                                    this.clearAddEditStructureFields()
                                    const updatedStructure = res.data;

                                    const index = this.items.findIndex(item => item.id === updatedStructure.id);
                                    if (index !== -1) {
                                        this.items[index].name = updatedStructure.name;
                                        this.items[index].nameAr = updatedStructure.nameAr;
                                        this.items[index].isEntityRecipient = updatedStructure.isEntityRecipient;
                                        this.items[index].parentId = updatedStructure.structureParentId;
                                    }

                                    const globalIndex = this.globalItems.findIndex(item => item.id === updatedStructure.id);
                                    if (globalIndex !== -1) {
                                        this.globalItems[globalIndex].name = updatedStructure.name;
                                        this.globalItems[globalIndex].nameAr = updatedStructure.nameAr;
                                        this.globalItems[globalIndex].isEntityRecipient = updatedStructure.isEntityRecipient;
                                        this.globalItems[globalIndex].parentId = updatedStructure.structureParentId;
                                    }

                                }
                            })
                            .catch(err => console.warn(err))
                            .finally(() => { window.hideLoading(); })
                    }
                    else
                        window.showAlert('res_Msgs_FillRequired', 'warning')
                }
                else {
                    if (this.structureForm.name && this.structureForm.nameAr) {
                        let addNewStructureBody = {
                            Code: this.structureForm.code,
                            Name: this.structureForm.name,
                            NameAr: this.structureForm.nameAr,
                            StructureParentId: this.selectedStructureId,
                            CreatedDate: Date.now,
                            External: false,
                            IsCompany: this.selectedStructureId == null ? true : this.structureForm.isCompany,
                            StorageDatabaseName: this.structureForm.storageDatabaseName,
                            StorageFile: this.structureForm.storageFile,
                            DisableTransfers: this.structureForm.disableTransfers,
                            AllowExternalCommunication: this.structureForm.allowExternalCommunication,
                            IsParentCounterFeatureEnabled: this.structureForm.isParentCounterFeatureEnabled,
                            Active: this.structureForm.active
                        }

                        window.showLoading();
                        axios.post(constants.baseApiUrl + 'StructureUser/AddStructureForTreeView', addNewStructureBody, { headers: constants.headers })
                            .then(res => {
                                if (res.data != null) {
                                    window.showAlert('res_Msgs_StructureAdded', 'success')
                                    this.clearAddEditStructureFields()

                                    const matchedItem = this.globalItems.find(x => x.id === this.selectedStructureId);
                                    if (matchedItem) {
                                        this.fetchCurrentStructure(matchedItem);
                                    }
                                }
                            })
                            .catch(err => console.warn(err))
                            .finally(() => window.hideLoading())
                    }
                    else
                        window.showAlert('res_Msgs_FillRequired', 'warning')
                }
            },
            clearAddEditStructureFields() {
                this.add_edit_Structure = false
                this.structureForm.code = ''
                this.structureForm.name = ''
                this.structureForm.nameAr = ''
                this.structureForm.external = false
                this.selectedParentId = null
                this.structureForm.isCompany = false
                this.structureForm.storageDatabaseName = ''
                this.structureForm.storageFile = ''
                this.structureForm.disableTransfers = false
                this.structureForm.allowExternalCommunication = true
                this.structureForm.isParentCounterFeatureEnabled = false
            },
            CapitalizeFirstLetter(str) {
                return utils.CapitalizeFirstLetter(str)
            },
            GetMultiSelectSubHeaderDisplay(options) {
                return utils.GetMultiSelectSubHeaderDisplay(options)
            },
            addParentStructure(parentId) {
                this.selectedStructureId = parentId;
                this.currentStructureMode = '';
                this.openOptionPane(4);
            },
            findStructureById(items, id) {
                for (let item of items) {
                    if (item.id === id) {
                        return item;
                    }
                    if (item.children) {
                        const found = this.findStructureById(item.children, id);
                        if (found) {
                            return found;
                        }
                    }
                }
                return null;
            },
            updateCompanyIdOfSelectedStructureId() {
                const node = this.findStructureById(this.items, this.selectedStructureId);
                if (!node) {
                    this.companyIdOfSelectedStructureId = 0;
                    return;
                }
                let current = node;
                while (current && current.parentId) {
                    const parent = this.findStructureById(this.items, current.parentId);
                    if (!parent) break;
                    current = parent;
                }
                this.companyIdOfSelectedStructureId = current ? current.id : 0;
                
            },
            removeItemByIdRecursive(items, idToRemove) {
                return items
                    .filter(item => item.id !== idToRemove)
                    .map(item => ({
                        ...item,
                        children: item.children ? this.removeItemByIdRecursive(item.children, idToRemove) : []
                    }));
            },
            openOptionPane(id) {
                this.updateCompanyIdOfSelectedStructureId()
                this.showMenu = false;
                this.showParentSelector = false;
                if (id != 15) this.showHeaderFooter = false;
                if (id == 1) {
                    this.showTemplateDelegation = false;
                    this.add_edit_Structure = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.footer = false;
                    this.showManageTemplates = false;
                    this.showStructureStampPane = false
                    this.showManageUsers = false;
                    this.showManageStructureStampPane = false
                    this.sendStructureIdProp = this.selectedStructureId
                    this.showSignSendPane = true;
                    this.showAutoForwardPane = false;
                    this.showExportUsersInStructure = false;
                    this.sendSignRuleKey += this.sendSignRuleKey + 1;
                    this.showEntityRecipient = false;
                }
                else if (id == 2) {

                    this.showAutoForwardPane = true;
                    this.templatKey += 1;
                    this.showMenu = false;
                    this.showTemplateDelegation = false;
                    this.showSignSendPane = false;
                    this.add_edit_Structure = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.showManageUsers = false;
                    this.footer = false;
                    this.showManageTemplates = false;
                    this.showStructureStampPane = false
                    this.showManageStructureStampPane = false
                    this.sendStructureIdProp = this.selectedStructureId
                    this.showExportUsersInStructure = false;
                    this.autoForwardKey += this.autoForwardKey + 1;
                    this.showEntityRecipient = false;
                }
                else if (id == 3) {
                    this.showSignSendPane = false;
                    this.add_edit_Structure = false;
                    this.showAutoForwardPane = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.footer = false;
                    this.showManageTemplates = false;
                    this.showManageUsers = false;
                    this.showStructureStampPane = false
                    this.showManageStructureStampPane = false
                    this.sendStructureIdProp = this.selectedStructureId
                    this.showTemplateDelegation = true;
                    this.showExportUsersInStructure = false;
                    this.templateDelagationKey += this.templateDelagationKey + 1;
                    this.showEntityRecipient = false;
                }
                else if (id == 4) {
                    this.showSignSendPane = false;
                    this.showAutoForwardPane = false;
                    this.showTemplateDelegation = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.footer = false;
                    this.showManageTemplates = false;
                    this.showManageUsers = false;
                    this.showStructureStampPane = false;
                    this.showManageStructureStampPane = false
                    this.showExportUsersInStructure = false;
                    this.resetFiles()
                    this.currentStructureMode = ' / (' + this.$t('res_Label_NewStructure') + ')'
                    this.add_edit_Structure = true;
                    this.showEntityRecipient = false;
                }
                else if (id == 5) {
                    this.showParentSelector = true;
                    this.showSignSendPane = false;
                    this.showAutoForwardPane = false;
                    this.showTemplateDelegation = false;
                    this.isEdit = true;
                    this.showUsername = false;
                    this.footer = false;
                    this.showManageTemplates = false;
                    this.showManageUsers = false;
                    this.showStructureStampPane = false;
                    this.showManageStructureStampPane = false
                    this.showExportUsersInStructure = false;
                    this.getSelectedStructureData(this.selectedStructureId);
                    this.currentStructureMode = ' / (' + this.$t('res_Label_EditStructure') + ')'
                    this.add_edit_Structure = true;
                    this.showEntityRecipient = false;
                }
                else if (id == 6) {
                    window.showInformation(this.$t("res_Msg_DeleteConfirmation"), this.$t("res_Msgs_DeleteItemStructureDepartment"),
                        () => {
                            window.showLoading();
                            axios.get(constants.baseApiUrl + 'StructureUser/DeleteStructureForTreeView?structureId=' + this.selectedStructureId, { headers: constants.headers })
                                .then(res => {
                                    if (res.data != null && res.data == true) {
                                        window.showAlert('res_Msgs_StructureDeleted', 'success')

                                        this.items = this.removeItemByIdRecursive(this.items, this.selectedStructureId);
                                        this.globalItems = this.globalItems.filter(item => item.id !== this.selectedStructureId);
                                    }
                                    else {
                                        window.showAlert('res_Msgs_StructureDeleteViolation', 'warning')
                                    }
                                })
                                .catch(err => console.warn(err))
                                .finally(() => { window.hideLoading(); })
                        },
                        () => { })
                }
                else if (id == 7) {
                    this.showSignSendPane = false
                    this.showAutoForwardPane = false;
                    this.showTemplateDelegation = false
                    this.isEdit = false
                    this.add_edit_Structure = false
                    this.footer = false
                    this.disableFields = false
                    this.disableMailField = false
                    this.showManageUsers = false;
                    this.image = null
                    this.showUsername = false
                    this.showStructureStampPane = false
                    this.showManageStructureStampPane = false
                    this.showManageTemplates = true
                    this.sendStructureIdProp = this.selectedStructureId;
                    this.showExportUsersInStructure = false;
                    this.showStructureStampKey += this.showStructureStampKey + 1;
                    this.showEntityRecipient = false;
                }
                else if (id == 8) {
                    window.showLoading();
                    axios.get(constants.baseApiUrl + 'StructureUser/ToggleActiveStructure?structureId=' + this.selectedStructureId, { headers: constants.headers })
                        .then(res => {
                            if (res.data != null && res.data.success) {
                                window.showAlert(res.data.message, 'success')
                                this.asyncStructuresTreeView();
                            }
                            else {
                                window.showAlert((res.data != null && res.data.message != '' ? res.data.message : 'res_Msgs_StructureActiveDeactiveViolation'), 'warning')
                            }
                        })
                        .catch(err => console.warn(err))
                        .finally(() => { window.hideLoading(); });
                }
                else if (id == 9) {
                    this.showTemplateDelegation = false;
                    this.showAutoForwardPane = false;
                    this.add_edit_Structure = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.footer = false;
                    this.showManageTemplates = false;
                    this.sendStructureIdProp = this.selectedStructureId
                    this.showManageUsers = false;
                    this.showSignSendPane = false;
                    this.showStructureStampPane = true;
                    this.showManageStructureStampPane = false
                    this.showExportUsersInStructure = false;
                    this.sendSignRuleKey += this.sendSignRuleKey + 1;
                    this.showEntityRecipient = false;
                }
                else if (id == 10) {
                    this.showTemplateDelegation = false;
                    this.showAutoForwardPane = false;
                    this.add_edit_Structure = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.footer = false;
                    this.showManageTemplates = false;
                    this.showManageUsers = false;
                    this.sendStructureIdProp = this.selectedStructureId
                    this.showSignSendPane = false;
                    this.showStructureStampPane = false;
                    this.showManageStructureStampPane = false
                    this.sendSignRuleKey += this.sendSignRuleKey + 1;
                    this.showExportUsersInStructure = false;
                    this.filingClassificationPlanMode = 1;
                    this.fillingPlanKey += this.fillingPlanKey + 1;
                    this.showEntityRecipient = false;
                }
                else if (id == 11) {
                    this.showTemplateDelegation = false;
                    this.showAutoForwardPane = false;
                    this.add_edit_Structure = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.footer = false;
                    this.showManageTemplates = false;
                    this.showManageUsers = false;
                    this.sendStructureIdProp = this.selectedStructureId
                    this.showSignSendPane = false;
                    this.showStructureStampPane = false;
                    this.showManageStructureStampPane = false
                    this.sendSignRuleKey += this.sendSignRuleKey + 1;
                    this.showExportUsersInStructure = false;
                    this.filingClassificationPlanMode = 2;
                    this.classificationKey += this.classificationKey + 1;
                    this.showEntityRecipient = false;
                }
                else if (id == 13) {
                    this.showTemplateDelegation = false;
                    this.showAutoForwardPane = false;
                    this.add_edit_Structure = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.footer = false;
                    this.showManageTemplates = false;
                    this.showManageUsers = false;
                    this.sendStructureIdProp = this.selectedStructureId
                    this.showSignSendPane = false;
                    this.showStructureStampPane = false;
                    this.showManageStructureStampPane = true
                    this.showExportUsersInStructure = false;
                    this.sendSignRuleKey += this.sendSignRuleKey + 1;
                    this.showEntityRecipient = false;
                }
                else if (id == 14) {
                    this.showSignSendPane = false;
                    this.add_edit_Structure = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.showAutoForwardPane = false;
                    this.sendStructureIdProp = this.selectedStructureId
                    this.footer = false;
                    this.showManageTemplates = false;
                    this.showStructureStampPane = false
                    this.showManageUsers = true;
                    this.showTemplateDelegation = false;
                    this.showManageStructureStampPane = false
                    this.showExportUsersInStructure = false;
                    this.manageUsersKey += this.manageUsersKey + 1;
                    this.structureProp = this.findStructureById(this.items, this.selectedStructureId);
                    this.showEntityRecipient = false;
                }
                else if (id == 15) {
                    this.showSignSendPane = false;
                    this.add_edit_Structure = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.sendStructureIdProp = this.selectedStructureId
                    this.footer = false;
                    this.showAutoForwardPane = false;
                    this.showManageTemplates = false;
                    this.showStructureStampPane = false
                    this.showManageUsers = false;
                    this.showTemplateDelegation = false;
                    this.showManageStructureStampPane = false
                    this.showExportUsersInStructure = false;
                    this.manageUsersKey += this.manageUsersKey + 1;
                    this.structureProp = this.items.find(x => x.id == this.selectedStructureId);
                    this.showHeaderFooter = true;
                    this.showEntityRecipient = false;
                }
                else if (id == 16) {
                    this.showSignSendPane = false;
                    this.add_edit_Structure = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.sendStructureIdProp = this.selectedStructureId
                    this.footer = false;
                    this.showAutoForwardPane = false;
                    this.showManageTemplates = false;
                    this.showStructureStampPane = false
                    this.showManageUsers = false;
                    this.showTemplateDelegation = false;
                    this.showManageStructureStampPane = false
                    this.showExportUsersInStructure = true;
                    this.showEntityRecipient = false;
                }
                else if (id == 17) {
                    this.showSignSendPane = false;
                    this.add_edit_Structure = false;
                    this.isEdit = false;
                    this.showUsername = false;
                    this.sendStructureIdProp = this.selectedStructureId
                    this.footer = false;
                    this.showAutoForwardPane = false;
                    this.showManageTemplates = false;
                    this.showStructureStampPane = false
                    this.showManageUsers = false;
                    this.showTemplateDelegation = false;
                    this.showFillingPlan = false;
                    this.showClassificationPlan = false;
                    this.showManageStructureStampPane = false
                    this.showExportUsersInStructure = false;
                    this.showEntityRecipient = true;

                    this.entityRecipientKey = this.entityRecipientKey + 1
                }
            },
        }
    }
</script>

<style scoped>
    .tree-section {
        max-height: calc(100% - 6rem);
    }

    .tree-section .v-treeview {
        min-height: 0;
        max-height: calc(100% - 6rem);
        overflow-y: auto;
    }

    .hideDeleteButton {
        display: none
    }

    .v-list-item:hover,
    .v-list-item[aria-expanded="true"] {
        background-color: #b8c0c8;
        color: #FFF !important;
    }

    .v-input--selection-controls {
        margin-top: 0px !important;
    }
</style>